// eslint-disable-next-line import/prefer-default-export
export const iosContent = [
  {
    title: '《有讲课堂隐私政策》将帮助您了解以下内容：',
    texts: [
      '1. 引言',
      '2. 定义',
      '3. 我们如何收集和使用您的个人信息',
      '4. 我们如何共享、转让、公开披露您的个人信息',
      '5. 关于使用Cookie和同类技术',
      '6. 我们对您个人信息的存储与保护',
      '7. 您管理个人信息的权利',
      '8. 我们如何处理未成年人的个人信息',
      '9. 本隐私政策如何更新',
      '10. 联系我们',
      '11. 争议解决',
      '附件一 第三方SDK目录'
    ]
  },
  {
    title: '1. 引言',
    texts: [
      '《有讲课堂隐私政策》（以下简称『本隐私政策』）阐述了广州酷思纬哲网络科技有限公司（以下简称『酷思纬哲』或『我们』）将如何处理用户（以下简称『您』）的个人信息，并申明了我们对保护您的个人隐私的承诺。有讲课堂（以下简称『本应用』)将以高度的勤勉、审慎义务对待您的个人信息，按照本隐私政策的规定使用和披露这些信息。我们可能会不时依据法律法规或业务调整对本隐私政策进行修订。',
      '为了更好的保护您的个人信息，请您在使用有讲课堂及其服务前，建议您仔细阅读更新后的《有讲课堂隐私政策》并确定了解我们对您的个人信息的处理规则。如您有任何疑问、意见、建议可通过本隐私政策第十条『联系我们』与我们联系。如您不同意该隐私政策中的任一条，请停止使用本应用及相关的服务。当您使用本应用及相关的服务，则表示您同意且完全理解本隐私政策的全部内容。'
    ]
  },
  {
    title: '2. 定义',
    texts: [
      '2.1. 个人信息：指以电子或者其他方式记录的能够单独或者与其他信息结合识别特定自然人身份或者反映特定自然人活动情况的各种信息；',
      '2.2. 个人敏感信息：指一旦泄露、非法提供或滥用可能危害人身和财产安全，极易导致个人名誉、身心健康受到损害或歧视性待遇等的个人信息。包括身份证件号码、个人生物识别信息、银行或其他资金账号、财产信息、行踪轨迹、交易信息、14岁以下（含）儿童的个人信息；',
      '2.3. 个人信息删除：指在实现日常业务功能所涉及的系统中去除个人信息的行为，使其保持不可被检索、访问的状态；',
      '2.4. 您：又称『用户』，是指任何以合法的方式获取和使用『有讲课堂』产品的人，不限于自然人和机构；',
      '2.5. 有讲课堂产品：又称『有讲课堂』，是指由酷思纬哲合法拥有并运营的、标注名称为『有讲课堂』的移动客户端应用程序以及对应域名为『yojiang.cn』的移动网站和PC网站。客户端应用程序以软件形式提供，用户必须选择与所安装终端设备相匹配的软件版本；',
      '2.6. Cookie：Cookie是包含字符串的小文件，在您登入和使用网站或其他网络内容时发送、存放在您的计算机、移动设备或其他装置内（通常经过加密）。Cookie同类技术是可用于与Cookie类似用途的其他技术，例如：ETag、Web Beacon、Proxy、嵌入式脚本等；',
      '2.7. 账号：当您注册账号并向我们提供一些个人信息，您就可以更好的使用我们的服务。当您访问有讲课堂时，系统会利用这些账号信息对您进行身份验证，以防止未经授权的人员访问您的账号。'
    ]
  },
  {
    title: '3. 我们如何收集和使用您的个人信息',
    texts: [
      '3.1. 我们依据法律法规以及遵循正当、合法、必要的原则，收集和使用您在使用本应用及其服务过程中主动提供的、以及通过自动化手段收集您在使用功能或接受服务过程中产生的信息；',
      '3.2. 我们不会向任何无关第三方提供、出售、出租、分享或交易您的个人信息，除非事先得到您的明确同意，或该第三方和本应用（含本应用关联公司）单独或共同为您提供服务，且在该服务结束后，其将被禁止访问包括其以前能够访问的所有这些资料；',
      '3.3. 我们亦不允许任何第三方以任何手段收集、编辑、出售或者无偿传播您的个人信息。任何本应用平台用户如从事上述活动，一经发现，本应用有权立即终止与该用户的服务协议；',
      '3.4. 如果我们欲将您的个人信息用于本隐私政策未说明的其他用途、或基于特定目的将收集的信息用于其他目的，我们将及时以合理的方式向您告知，并在使用前征得您的明确同意；',
      '3.5. 我们会对我们的产品与/服务使用情况进行统计，并可能会与公众或第三方共享这些统计信息，以展示我们的产品与/或服务的整体使用趋势，但这些统计信息不包含您的任何身份识别信息；',
      '3.6. 当您浏览、点赞、收藏我们有讲产品中提供的内容，我们只会针对阅读量和点赞数进行统计，该操作未收集您的个人信息。同时，目前我们未收集用户搜索、浏览记录、使用习惯等个人信息，用于定向推送或精准营销。',
      '3.7. 当我们展示您的个人信息时，我们会采用包括内容替换、匿名处理方式对您的信息进行脱敏，以保护您的信息安全；',
      '3.8. 通常情况下，我们将在以下场景收集、使用您的个人信息：',
      '3.8.1. 注册',
      '一、 当您注册、登录有讲及相关服务时，您可以通过手机号（个人敏感信息，用户接受验证码匹配个人身份）创建账号，并且您可以完善相关的网络身份识别信息（头像、昵称），如您拒绝提供此类信息，可以选择使用第三方账号登录，但此操作不能保障第三方账号被盗情况下有讲课堂产品的账号安全，请您谨慎考虑后再选择是否提供；',
      '二、 您也可以使用第三方账号（微信、QQ、微博）登录并使用本应用，您将授权我们获取您在第三方平台注册的公开信息（头像、昵称），用于与有讲账号绑定，使您可以直接登录并使用本产品及相关服务；',
      '三、 同时，您需理解，我们承诺，收集上述信息是用于为你提供账号登录服务以及保障您的账号安全，防范安全风险。手机号码和验证码匹配结果属于您的个人敏感信息，我们收集该类信息是基于法律法规的相关要求；',
      '四、 您还可以根据自身需求选择填写简介、性别、生日、学习目的、感兴趣的、所在地、学历、行业以及职业来完善您的信息。',
      '3.8.2. 信息发布',
      '一、 你发布音视频、图片等内容或进行评论时，我们将收集您发布的信息，并展示您的昵称、头像、发布内容和信息；',
      '二、 您使用发布图片、音视频功能时，我们会请求您授权相机、图片、麦克风权限。如果您拒绝授权提供，将无法使用此功能，但不影响您正常使用本应用提供的其他服务；',
      '三、 用户因使用我们的产品或者服务而被我们收集的信息，例如其他用户发布的信息中可能包含您的部分信息。',
      '3.8.3. 互动',
      '当您关注账号、进行浏览、评论、关注或者收藏、点赞或分享时，我们会收集您关注的账号和前述信息，并展示关注账号发布内容。',
      '3.8.4. 搜索',
      '一、 您使用有讲的搜索服务时，我们会收集您的搜索关键字信息、日志记录；',
      '二、 为了提供高效的搜索服务，部分前述信息会暂时存储在您的本地存储设备之中，并可向您展示搜索结果内容、搜索历史记录。除非您主动与人分享，前述信息展示仅对您单独可见。您可在搜索页面删除所有搜索历史。',
      '3.8.5. 客服',
      '当您向本应用发起反馈、咨询时，为了您的账号与系统安全，我们可能需要您提供账号信息，并与您之前的个人信息相匹配以验证您的用户身份。同时，为了方便与您联系/帮助您解决问题，我们可能需要您姓名、手机号码及其他联系方式等个人信息。另外，我们还会收集您与我们的沟通信息（包括文字/图片/音视频/通话记录等形式）、与您的需求相关联的其他必要信息。我们收集这些信息是为了调查事实与帮助您解决问题，如您拒绝提供上述信息，我们可能无法向您及时回应反馈或咨询结果。',
      '3.8.6. 支付',
      '当您在本应用上开通会员服务、购买课堂等发生支付行为时，需要使用到支付功能。在支付过程中，我们可能会收集您的第三方支付渠道的userID（例如支付宝userID、微信openID）。上述信息为我们向您提供您购买商品/服务所必须的信息，我们无法仅根据该信息获得您的个人财产信息，也不能识别特定自然人身份信息。',
      '3.8.7. 发送通知',
      '我们可能会将您的个人信息用于发送重要通知，例如有关订单的通知，由于此类信息对您和我们之间的沟通至关重要，不建议您拒绝接收此类信息；若您向关闭该模块服务，您可以通过人工客服方式与我们联系。',
      '3.8.8. 学习报告',
      '我们为您提供学习统计报告功能，记录您的学习数据为您提供证书、学习报告，为此我们需要获取您的账号、软件使用记录以实现前述功能。',
      '3.9. 其他附加服务',
      '本应用在使用过程中默认不开启相关权限，只有经过您的明示授权才会在为特定功能或服务时使用，您也可以在手机系统设置中撤回授权。特别需要指出的是，即使经过您的授权，我们获得了这些敏感权限，也不会在相关功能或服务不需要时而收集您的信息。',
      '3.9.1. 读取外置存储器',
      '允许APP读取存储中的图片、音视频等内容，主要用于帮助您发布图片和音视频信息。如果您不开启相应权限，您将无法使用与此权限相关的特定功能，但不影响您使用本应用提供的其他服务；',
      '3.9.2. 写入外置存储器',
      '允许APP写入、更新下载、保存存储器中的图片以及音视频资源下载。如果您不开启相应权限，您将无法使用与此权限相关的特定功能，但不影响您使用本应用提供的其他服务；',
      '3.9.3. 摄像头及相机权限',
      '当您登录注册设置头像或者进行直播时，您需要开启此权限，以便您进行实时拍摄或者图片、视频上传。如果您不开启相应权限，您将无法使用与实时拍摄或者图片、视频上传相关的特定功能，但不影响您使用本应用提供的其他服务；',
      '3.9.4. 麦克风权限',
      '当您使用直播功能时，您需要开启此权限，控制播放音量，并使用麦克风进行语音输入。如果您不开启相应权限，您将无法使用与此权限相关的特定功能，但不影响您使用本应用提供的其他服务。',
      '3.9.4. 地理位置获取权限',
      '允许在拍摄照片或视频时访问位置，以便于为您拍摄的照片或视频添加位置信息。如果您不开启相应权限，您将无法为您拍摄的照片或视频添加位置信息，但不影响您使用本应用提供的其他服务。',
      '3.10. 请您知悉，根据法律法规的规定，在以下情况下，我们无需取得您的授权同意即可收集和使用您的个人信息：',
      '3.10.1. 与国家安全、国防安全有关的；',
      '3.10.2. 与公共安全、公共卫生、重大公共利益相关的；',
      '3.10.3. 与犯罪侦查、起诉、审判和判决执行等直接相关的；',
      '3.10.4. 出于维护您或其他个人的生命、财产等重大合法权益但又很难得到您本人同意的；',
      '3.10.5. 所收集的信息是您自行向社会公开的或者是从合法公开的渠道（如合法的新闻报道、政府信息公开等渠道）中收集到的；',
      '3.10.6. 根据与您签订和履行相关政策或其他书面文件所必需的；',
      '3.10.7. 有权机关的要求、法律法规等规定的其他情形。'
    ]
  },
  {
    title: '4. 我们如何共享、转让、公开披露您的个人信息',
    texts: [
      '4.1. 共享',
      '我们重视对您的个人信息的保护，您的个人信息是我们为您提供产品与/或服务的重要依据和组成部分，对于您的个人信息，我们仅在本隐私政策所述目的和范围内或根据法律法规的要求收集和使用，并严格保密。通常情况下，我们不会与任何公司、组织和个人共享您的个人信息，但以下情况除外：',
      '4.1.1. 事先已获得您的明确授权或同意；',
      '4.1.2. 根据适用的法律法规、法律程序、政府的强制命令或司法裁定而需共享您的个人信息；',
      '4.1.3. 在法律要求或允许的范围内，为了保护有讲课堂产品及其用户或社会公众的利益、财产或安全免遭损害而有必要提供您的个人信息给第三方；',
      '4.1.4. 您的个人信息可能会在我们的关联公司之间共享。我们只会共享必要的个人信息，且这种共享亦受本隐私政策声明目的的约束。关联公司如要改变个人信息的处理目的，将再次征求您的授权同意；',
      '4.1.5. 为了向您提供更完善、优质的产品和服务，我们的某些服务将由授权合作伙伴提供。我们可能会与合作伙伴共享您的某些个人信息，以提供更好的客户服务和用户体验。我们仅会出于合法、正当、必要、特定、明确的目的共享您的个人信息，并且只会共享提供服务所必要的个人信息。目前，我们会在以下情形中，向您征求您对共享个人信息的授权同意：',
      '一、 支付功能：支付功能由与我们合作的第三方支付机构向您提供服务。第三方支付机构可能需要收集您的姓名、手机号、银行卡号等。银行卡号及手机号码等是个人敏感信息，是支付功能所必需的信息，拒绝提供将导致您无法使用该功能，但不影响其他功能的使用；',
      '二、 订单功能：当您使用有讲平台购买课程、创建订单时，经过您的授权，我们可能会与支付的相关服务提供方共享您的订单信息以方便您统一查询订单信息；',
      '三、 本应用集成友盟+SDK，友盟+SDK需要收集您的设备Mac地址、唯一设备识别码（IMEI/android ID/IDFA/OPENUDID/GUID、SIM 卡 IMSI 信息）以提供统计分析服务，并通过地理位置校准报表数据准确性，提供基础反作弊能力。若您不希望使用该SDK收集处理您的信息，您可以通过访问 https://outdip.umeng.com/opt_out.html 行使opt-out权利；',
      '四、 为保障有讲APP相关功能的实现与应用安全稳定运行，我们产品中可能会包含第三方SDK或其他类似应用程序，如您在我们平台上使用这类由第三方提供的服务时，您同意将由其直接收集和处理您的信息。前述服务商收集和处理信息等行为遵守其自身的隐私条款，而不适用于本隐私政策。您可以查看附件一 第三方SDK目录并了解其隐私政策。',
      '4.2. 公开披露',
      '公开披露是指向社会或不特定人群发布信息的行为。正常情况下我们不会对您的个人信息进行公开披露。如具备合理事由确需公开披露的，我们会在公开披露之前向您告知公开披露的信息的目的、类型，如涉及个人敏感信息的，我们会向您告知涉及的敏感信息的内容，并在征得您明确同意后再公开披露，但法律法规另有规定或本隐私政策另有约定的除外。',
      '仅在如下情况下，本应用将公开披露您的个人信息：',
      '4.2.1. 事先获得您的明确同意；',
      '4.2.2. 为提供您所要求的产品和服务，而必须和第三方分享您的个人信息；',
      '4.2.3. 根据法律的有关规定，或者行政或司法机构的要求，向第三方或者行政、司法机构披露；',
      '4.2.4. 如您出现违反中国有关法律、法规或者本应用服务政策或相关规则的情况，需要向第三方披露；',
      '4.2.5. 如您是知识产权投诉人并已提起投诉，应被投诉人要求，向被投诉人披露，以便双方处理可能的权利纠纷；',
      '4.2.6. 在本应用平台上创建的某一交易中，如交易任何一方履行或部分履行了交易义务并提出信息披露请求的，本应用有权决定向该用户提供其交易对方的联络方式等必要信息，以促成交易的完成或纠纷的解决；',
      '4.2.7. 其它本应用根据法律、法规或者网站政策认为合适的披露。',
      '4.3. 转让',
      '4.3.1. 除非获得您的明确同意，我们不会将您的个人信息转让给任何公司、组织或个人。',
      '4.3.2. 如发生合并、收购或破产清算情形，将可能涉及个人信息转让，此种情况下我们会要求心得持有您个人信息的公司、组织继续受本隐私政策的约束，否则我们将要求该公司、组织和个人重新向您征求授权同意。',
      '4.4. 请您知悉，根据法律法规的规定，在以下情况下，共享、公开披露、转让您的个人信息无需取得您的授权同意即：',
      '4.4.1. 与国家安全、国防安全有关的；',
      '4.4.2. 与公共安全、公共卫生、重大公共利益相关的；',
      '4.4.3. 与犯罪侦查、起诉、审判和判决执行等直接相关的；',
      '4.4.4. 出于维护您或其他个人的生命、财产等重大合法权益但又很难得到您本人同意的；',
      '4.4.5. 所收集的信息是您自行向社会公开的或者是从合法公开的渠道（如合法的新闻报道、政府信息公开等渠道）中收集到的；',
      '4.4.6. 根据与您签订和履行相关政策或其他书面文件所必需的；',
      '4.4.7. 有权机关的要求、法律法规等规定的其他情形。'
    ]
  },
  {
    title: '5. 关于使用Cookie和同类技术',
    texts: [
      '5.1. Cookie和设备信息标识等同类技术是互联网中普遍使用的技术。当您使用有讲课堂产品时，我们可能会使用相关技术向您的设备发送一个或多个Cookie或匿名标识符，以收集、标识您访问、使用本产品时的信息。我们承诺，不会将Cookie和同类技术用于本隐私政策所述目的外的任何途径。',
      '5.2. 您有权选择接受或拒绝接受Cookie和同类技术收集和使用您的相关信息。您可以通过修改浏览器设置的方式管理、拒绝Cookie与/或同类技术，或删除已经存储在您的计算机、移动设备或其他装置内的Cookie与/或同类技术，例如，您可以在APP首页下方『我的』》右上角『设置』》『清除缓存』，清除缓存的Cookie信息，从而实现我们无法全部或部分追踪您的个人信息。',
      '5.3. 如果您选择拒绝接受Cookie或同类技术，则您可能无法登录或无法使用依赖于Cookie的本应用网络服务或功能，同时也可能对您的信息保护和账号安全性造成一定的影响；',
      '5.4. 通过本应用所设Cookie和同类技术所取得的有关信息，将适用本隐私政策。'
    ]
  },
  {
    title: '6. 我们对您个人信息的存储与保护',
    texts: [
      '6.1. 信息存储',
      '6.1.1. 存储地点：',
      '我们依照法律法规的规定，仅会将收集到的有关您的个人信息存储于中华人民共和国境内。如果确有必要进行数据的跨境传输，我们会单独向您明确告知并征得您的授权同意，同时我们会确保数据接收方有充足的数据保护能力来保护您的个人信息。',
      '6.1.2. 存储期限：',
      '我们只会在达到本隐私政策所述目的所需的期限内保留您的个人信息，除非法律有强制的存留要求。而我们判断前述期限的标准包括：',
      '一、 完成与您相关的服务目的、维护相应服务及业务记录、应对您可能的查询或投诉；',
      '二、 保证我们为您提供服务的安全和质量；',
      '三、 您是否同意更长的留存期间；',
      '四、 是否存在保留期限的其他特别约定。',
      '五、 在您的个人信息超出保留期限后，我们会根据适用法律的要求删除您的个人信息。',
      '6.2. 信息保护',
      '6.2.1. 我们非常重视您个人信息的安全，将努力采取合理的安全措施，包括技术方面和管理方面来保护您的个人信息，防止您提供的个人信息被不当使用或在未经授权的情况下被访问、公开披露、使用、修改、损坏、丢失或泄露。',
      '6.2.2. 我们将采取严格的数据访问制度，确保只有授权人员才可访问您的个人信息，并适时对数据和技术进行安全审计。',
      '6.2.3. 希望您知悉并理解，您接入本应用的系统和通讯网络，可能因我们可控范围外的因素而出现问题。我们强烈建议您采取积极措施保护个人信息的安全，包括但不限于定期修改第三方账号密码、使用手机号验证码登录方式等，',
      '6.2.4. 尽管已经采取了合理有效的措施，并遵守相关法律法规要求的标准，在使用本应用网络服务进行网上交易时存在着各种恶意手段，我们不能保证信息百分百的安全，我们将尽力确保您提供给我们的个人信息的安全性。',
      '6.2.5. 如您发现自己的个人信息泄密，请您立即通过本隐私政策第十条提供的方式联系我们，以便我们采取相应措施。'
    ]
  },
  {
    title: '7. 您管理个人信息的权利',
    texts: [
      '我们非常重视您对个人信息的关注，并尽全力保护您对于自己个人信息访问、更正、删除以及撤回授权的权利，以使您拥有充分的能力保障您的隐私和安全。您的权利包括：',
      '7.1. 访问您的个人信息',
      '你可以按照我们提供的产品和服务的相关说明（设置），对您已提供给我们的相关个人信息进行查阅。包括：',
      '7.1.1. 账号信息：您可以通过相关产品页面随时访问或编辑您的个人资料信息，登录账号后通过我的》设置》个人资料查看此类信息，包括：头像、昵称、简介、ID、性别、生日、学习目的、感兴趣的、所在地、学历、行业、职业；',
      '7.1.2. 使用信息：您可以通过相关产品页面随时查阅您的使用信息，包括：收藏内容、下载内容、我的直播间内容、学习记录等；',
      '7.1.3. 其他信息：如您在访问过程中遇到操作问题需获取其他前述无法获知的个人信息内容，您可通过本隐私政策第十条提供的方式联系我们。',
      '7.2. 更正/修改您的个人信息',
      '7.2.1. 当您发现您提供给我们的个人信息存在登记错误、不完整或有更新的，您可在我们的产品和/或服务中更正/修改您的个人信息。',
      '7.2.2. 对于您的部分个人信息，我们在产品的相关功能页面为您提供了操作设置，您可以直接进行更正/修改，例如：“头像/昵称/性别/生日”等在客户端中的更正/修改路径为：我的》设置》个人资料。',
      '7.2.3. 对于您在行使上述权利过程中遇到的困难，或者其他可能目前无法向您提供在线自行更正/修改服务的，经过对您身份的验证，且更正/修改不影响信息的客观性和准确性的情况下，您有权对错误或不完整的信息作出更正或修改，或在特定情况下，尤其是数据错误时，通过我们公布的反馈与报错等措施将您的更正/修改申请提交给我们，要求我们更正或修改您的数据，但法律法规另有规定的除外。',
      '7.3. 删除您的个人信息',
      '当发生以下情况时，您可以直接要求我们删除您的个人信息：',
      '一、 当我们处理个人信息的行为违反法律法规时；',
      '二、 当我们收集、使用您的个人信息，却未征得您的同意时；',
      '三、 当我们处理个人信息的行为违反了与您的约定时；',
      '四、 当您注销了本应用账号时；',
      '五、 当我们终止服务及运营时。',
      '7.4. 管理/撤回授权',
      '前文所述，我们提供的产品和服务的部分功能需要获得您使用设备的相关权限（包括：位置、相机、麦克风等，具体以产品实际获取的功能为准）。您可以在授权后随时撤回（或停止）对该权限的继续授权。如在IOS客户端撤回授权的路径为：设置》有讲课堂，选择具体权限拒绝授权即可。',
      '您需理解，当您撤回授权后，我们无法继续为您提供撤回授权所对应的特定功能和/或服务。但您撤回授权的决定，不会影响此前基于您的授权而开展的个人信息处理。',
      '您也可以通过注销账号的方式，永久撤回我们继续收集您个人信息的全部授权。',
      '7.5. 注销账号',
      '您可以在我们的产品或服务中直接申请注销账户。关于您注销账户的方式以及您应满足的条件，请详见“注销账户”页面。 您注销账户后，我们将停止为您提供产品/服务，并依据您的要求，除法律法规另有规定外，我们将删除您的个人信息。如果您对注销账号有疑问的，您可通过本隐私政策第十条提供的方式联系我们。',
      '“注销账户”页面的查询方式：APP端：APP首页下方『我的』》右上角『设置』》『账号与安全』》『注销账号』。'
    ]
  },
  {
    title: '8. 我们如何处理未成年人的个人信息',
    texts: [
      '8.1. 我们的服务主要面向成年人（原则上18周岁以上为成年人，16周岁以上且以自己的劳动成果为主要生活来源的，我们亦视为成年人）。',
      '8.2. 如您为未成年人，未成年人使用我们的产品与/或服务前应取得其监护人的同意，在使用我们的产品与/或服务前，应在监护人监护、指导下共同阅读本隐私政策且应在监护人明确同意和指导下使用我们的产品与/或服务或向我们提供信息。',
      '8.3. 我们根据国家相关法律法规的规定保护未成年人的个人信息，只会在法律法规允许、监护人明确同意或保护您的权益所必要的情况下收集、使用或公开披露未成年人的个人信息；',
      '8.4. 如您的监护人不同意您按照本隐私政策使用我们的服务或向我们提供信息，请您立即终止使用我们的服务并及时通知我们；',
      '8.5. 若您是未成年人的监护人，当您对您所监护的未成年人的个人信息有相关疑问时，您可以通过本隐私政策第十条“联系我们”中公示的联系方式与我们沟通解决。如果我们发现在未事先获得可证实的监护人同意的情况下收集了未成年人的个人信息，则会尽快删除相关数据。'
    ]
  },
  {
    title: '9. 本隐私政策如何更新',
    texts: [
      '9.1. 为给您提供更好的服务以及随着我们业务的发展，可能会对本应用的功能和提供的服务有所调整变化。原则上，当新功能或服务与我们当前提供的功能或服务相关时，收集与使用的个人信息将与原处理的目的具有直接或合理关联。在与原处理的无直接或合理关联的场景下，我们收集、使用您的个人信息，会再次进行告知，并征得您的同意。未经您明确同意，我们不会削减您依据本隐私政策所应享受的权利。',
      '9.2. 如果决定更改本隐私政策，我们会在本协议中、公司网站中以及我们认为适当的位置发布这些更改，以便您了解我们如何收集、使用您的个人信息，哪些人可以访问这些信息，以及在什么情况下我们会透露这些信息。',
      '9.3. 我们将保留随时修改本隐私政策的权利，因此请经常查看。您可以在有讲课程APP通过以下方式查阅我们的最新的隐私政策：『我的』》右上角『设置』按钮 》『隐私政策』。'
    ]
  },
  {
    title: '10. 联系我们',
    texts: [
      '如您对本隐私政策有任何疑问、意见或建议，或您在使用我们提供的服务时个人信息受到了侵扰，您可以通过以下几种方式联系我们，我们将尽快审核所涉问题，一般情况下，我们将在15个工作日内回复。',
      '一、 您可以通过以下方式直接与我们的客服联系：',
      '联系方式：020-87553865；',
      '电子邮箱地址：hezhihao@yojiang.cn;',
      '二、 周一至周五 09：00~18：00可通过有讲课堂APP与我们的客服联系，联系客服的路径是：『首页』》右上角『客服』；',
      '三、 通过意见反馈的方式将您的意见、反馈等发送给我们，意见反馈的路径是：『我的』》『意见反馈』；'
    ]
  },
  {
    title: '11. 争议解决',
    texts: [
      '11.1. 因本隐私政策生效、履行、解释及使用本应用平台或服务而产生或与本隐私政策相关的一切争议、权利主张或其他事项，均适用中华人民共和国大陆地区法律。',
      '11.2. 任何因本隐私政策以及我们处理您的个人信息事宜引起的争议，应先友好协商，如协商不成的，任何一方可选择按下述任一途径解决：',
      '一、 提交仲裁委员会，按照申请仲裁时现行有效的仲裁规则进行仲裁；仲裁裁决为终局裁决，对双方均有法律约束力；',
      '二、 提交协议签订地人民法院诉讼管辖；',
      '本隐私政策的标题仅为方便及阅读而设，并不影响正文其中任何规定的含义或解释。',
      '请您再次确认您已全部阅读并充分理解上述条款。'
    ]
  }
];

export const androidContent = [
  {
    title: '《有讲课堂隐私政策》将帮助您了解以下内容：',
    texts: [
      '1. 引言',
      '2. 定义',
      '3. 我们如何收集和使用您的个人信息',
      '4. 我们如何共享、转让、公开披露您的个人信息',
      '5. 关于使用Cookie和同类技术',
      '6. 我们对您个人信息的存储与保护',
      '7. 您管理个人信息的权利',
      '8. 我们如何处理未成年人的个人信息',
      '9. 本隐私政策如何更新',
      '10. 联系我们',
      '11. 争议解决',
      '12. 第三方SDK目录'
    ]
  },
  {
    title: '1. 引言',
    texts: [
      '《有讲课堂隐私政策》（以下简称『本隐私政策』）阐述了广州酷思纬哲网络科技有限公司（以下简称『酷思纬哲』或『我们』）将如何处理用户（以下简称『您』）的个人信息，并申明了我们对保护您的个人隐私的承诺。有讲课堂（以下简称『本应用』)将以高度的勤勉、审慎义务对待您的个人信息，按照本隐私政策的规定使用和披露这些信息。我们会不时依据法律法规或业务调整对本隐私政策进行修订。',
      '为了更好的保护您的个人信息，请您在使用有讲课堂及其服务前，建议您仔细阅读更新后的《有讲课堂隐私政策》并确定了解我们对您的个人信息的处理规则。如您有任何疑问疑问、意见、建议，可通过本隐私政策第十条『联系我们』与我们联系。如您不同意本隐私政策中的任一条，请停止使用本应用及其相关的服务。当您使用本应用及其相关的服务，则表示您同意且完全理解本隐私政策的全部内容。'
    ]
  },
  {
    title: '2. 定义',
    texts: [
      '2.1. 个人信息：指以电子或者其他方式记录的能够单独或者与其他信息结合识别特定自然人身份或者反映特定自然人活动情况的各种信息；',
      '2.2. 个人敏感信息：指一旦泄露、非法提供或滥用可能危害人身和财产安全，极易导致个人名誉、身心健康受到损害或歧视性待遇等的个人信息。包括身份证件号码、个人生物识别信息、银行或其他资金账号、财产信息、行踪轨迹、交易信息、14岁以下（含）儿童的个人信息；',
      '2.3. 个人信息删除：指在实现日常业务功能所涉及的系统中去除个人信息的行为，使其保持不可被检索、访问的状态；',
      '2.4. 您：又称『用户』，是指任何以合法的方式获取和使用『有讲课堂』产品的人，不限于自然人和机构；',
      '2.5. 有讲课堂产品：又称『有讲课堂』，是指由酷思纬哲合法拥有并运营的、标注名称为『有讲课堂』的移动客户端应用程序以及对应域名为『yojiang.cn』的移动网站和PC网站。客户端应用程序以软件形式提供，用户必须选择与所安装终端设备相匹配的软件版本；',
      '2.6. Cookie：Cookie是包含字符串的小文件，在您登入和使用网站或其他网络内容时发送、存放在您的计算机、移动设备或其他装置内（通常经过加密）。Cookie同类技术是可用于与Cookie类似用途的其他技术，例如：ETag、Web Beacon、Proxy、嵌入式脚本等；',
      '2.7. 账号：当您注册账号并向我们提供一些个人信息，您就可以更好的使用我们的服务。当您访问有讲课堂时，系统会利用这些账号信息对您进行身份验证，以防止未经授权的人员访问您的账号。'
    ]
  },
  {
    title: '3. 我们如何收集和使用您的个人信息',
    texts: [
      '3.1. 我们依据法律法规以及遵循正当、合法、必要的原则，收集和使用您在使用本应用及其服务过程中主动提供的、以及通过自动化手段收集您在使用功能或接受服务过程中产生的信息；',
      '3.2. 我们不会向任何无关第三方提供、出售、出租、分享或交易您的个人信息，除非事先得到您的明确同意，或该第三方和本应用（含本应用关联公司）单独或共同为您提供服务，且在该服务结束后，其将被禁止访问包括其以前能够访问的所有这些资料；',
      '3.3. 我们亦不允许任何第三方以任何手段收集、编辑、出售或者无偿传播您的个人信息。任何本应用平台用户如从事上述活动，一经发现，本应用有权立即终止与该用户的服务协议；',
      '3.4. 如果我们欲将您的个人信息用于本隐私政策未说明的其他用途、或基于特定目的将收集的信息用于其他目的，我们将及时以合理的方式向您告知，并在使用前征得您的明确同意。',
      '3.5. 我们会对我们的产品与/服务使用情况进行统计，并会与公众或第三方共享部分统计信息，以展示我们的产品与/或服务的整体使用趋势，但这些统计信息不包含您的任何身份识别信息；',
      '3.6. 当您浏览、点赞、收藏我们有讲产品中提供的内容，我们只会针对阅读量和点赞数进行统计，该操作未收集您的个人信息。同时，目前我们未收集用户搜索、浏览记录、使用习惯等个人信息，用于定向推送或精准营销。',
      '3.7. 当我们展示您的个人信息时，我们会采用包括内容替换、匿名处理方式对您的信息进行脱敏，以保护您的信息安全；',
      '3.8. 通常情况下，我们将在以下场景收集、使用您的个人信息：',
      '3.8.1. 注册',
      '一、 当您注册、登录有讲课堂产品时，您可以通过手机号（个人敏感信息，用户接受验证码匹配个人身份）创建账号，并且您可以完善相关的网络身份识别信息（头像、昵称），如您拒绝提供此类信息，可以选择使用第三方账号登录，但此操作不能保障第三方账号被盗情况下有讲课堂产品的账号安全，请您谨慎考虑后再选择是否提供；',
      '二、 您也可以使用第三方账号（微信、QQ、微博）登录并使用本应用，您将授权我们获取您在第三方平台注册的公开信息（头像、昵称），用于与有讲账号绑定，使您可以直接登录并使用本产品及相关服务；',
      '三、 同时，您需理解，我们承诺，收集上述信息是用于为你提供账号登录服务以及保障您的账号安全，防范安全风险。手机号码和验证码匹配结果属于您的个人敏感信息，我们收集该类信息是基于法律法规的相关要求；',
      '四、 您还可以根据自身需求选择填写简介、性别、生日、学习目的、感兴趣的、所在地、学历、行业以及职业来完善您的信息。',
      '3.8.2. 信息发布',
      '一、 您发布音视频、图片等内容或进行评论时，我们将收集您发布的信息，并展示您的昵称、头像、发布内容和信息；',
      '二、 您使用发布图片、音视频的功能时，我们会请求您授权相机、图片、麦克风权限。如果您拒绝授权提供，将无法使用此功能，但不影响您正常使用本应用提供的其他服务；',
      '三、 用户因使用我们的产品或者服务而被我们收集的信息，例如其他用户发布的信息中包含您的部分信息等。',
      '3.8.3. 互动',
      '当您进行浏览、评论、关注、收藏、点赞或分享时，我们会收集您关注的账号和前述信息，并展示关注账号发布内容。',
      '3.8.4. 搜索',
      '一、 您使用有讲的搜索服务时，我们会收集您的搜索关键字信息、日志记录；',
      '二、 为了提供高效的搜索服务，部分前述信息会暂时存储在您的本地存储设备之中，并可向您展示搜索结果内容、搜索历史记录。除非您主动与人分享，前述信息展示仅对您单独可见。您可在搜索页面删除所有搜索历史。',
      '3.8.5. 客服',
      '当您向本应用发起反馈、咨询时，为了您的账号与系统安全，我们需要您提供账号信息，并与您之前的个人信息相匹配以验证您的用户身份。同时，为了方便与您联系/帮助您解决问题，我们将根据实际情况判断并加以说明是否需要您提供姓名、手机号码及其他联系方式等个人信息。另外，我们还会收集您与我们的沟通信息（包括文字/图片/音视频/通话记录等形式）、与您的需求相关联的其他必要信息。我们收集这些信息是为了调查事实与帮助您解决问题，如您拒绝提供上述信息，我们可能无法向您及时回应反馈或咨询结果。',
      '3.8.6. 支付',
      '当您在本应用上开通会员服务、购买课堂等发生支付行为时，需要使用到支付功能。在支付过程中，我们需要收集您的第三方支付渠道的userID（例如支付宝userID、微信openID）。上述信息为我们向您提供您购买商品/服务所必须的信息，我们无法仅根据该信息获得您的个人财产信息，也不能识别特定自然人身份信息。',
      '3.8.7. 发送通知',
      '在一些特定场景下，我们需要收集您的个人信息用于发送重要通知，例如有关订单的通知，由于此类信息对您和我们之间的沟通至关重要，不建议您拒绝接收此类信息；若您想关闭该模块服务，您可以通过人工客服方式与我们联系。',
      '我们会向您推送推广活动、广告，您可以根据喜好自行决定开启或关闭，在本产品中此推送服务不涉及精准推送，因此不涉及您的个人隐私问题。',
      '3.8.8. 学习报告',
      '我们为您提供学习统计报告功能，记录您的学习数据为您提供证书、学习报告，为此我们需要获取您的账号、软件使用记录以实现前述功能。'
    ]
  },
  {
    title: '4. 我们如何共享、转让、公开披露您的个人信息',
    texts: [
      '4.1. 共享',
      '我们重视对您的个人信息的保护，您的个人信息是我们为您提供产品与/或服务的重要依据和组成部分，对于您的个人信息，我们仅在本隐私政策所述目的和范围内或根据法律法规的要求收集和使用，并严格保密。通常情况下，我们不会与任何公司、组织和个人共享您的个人信息，但以下情况除外：',
      '4.1.1. 事先已获得您的明确授权或同意；',
      '4.1.2. 根据适用的法律法规、法律程序、政府的强制命令或司法裁定而需共享您的个人信息；',
      '4.1.3. 在法律要求或允许的范围内，为了保护有讲课堂产品及其用户或社会公众的利益、财产或安全免遭损害而有必要提供您的个人信息给第三方；',
      '4.1.4. 您的个人信息可能会在我们的关联公司之间共享。我们只会共享必要的个人信息，且这种共享亦受本隐私政策声明目的的约束。关联公司如要改变个人信息的处理目的，将再次征求您的授权同意；',
      '4.1.5. 为了向您提供更完善、优质的产品和服务，我们的某些服务将由授权合作伙伴提供。我们会与合作伙伴共享您的某些个人信息，以提供更好的客户服务和用户体验。我们仅会出于合法、正当、必要、特定、明确的目的共享您的个人信息，并且只会共享提供服务所必要的个人信息。目前，我们会在以下情形中，向您征求您对共享个人信息的授权同意：',
      '一、 支付功能：支付功能由与我们合作的第三方支付机构向您提供服务。第三方支付机构需要收集您的姓名、手机号、银行卡号等。银行卡号及手机号码等个人敏感信息，是支付功能所必需的信息，拒绝提供将导致您无法使用该功能，但不影响其他功能的使用；',
      '二、 订单功能：当您使用有讲平台购买课程、创建订单时，经过您的授权，我们可能会与支付的相关服务提供方共享您的订单信息以方便您统一查询订单信息；',
      '三、 本应用集成友盟+SDK，友盟+SDK需要收集您的设备Mac地址、唯一设备识别码（IMEI/android ID/IDFA/OPENUDID/GUID、SIM 卡 IMSI 信息）以提供统计分析服务，并通过地理位置校准报表数据准确性，提供基础反作弊能力。若您不希望使用该SDK收集处理您的信息，您可以通过访问 https://outdip.umeng.com/opt_out.html 行使opt-out权利；',
      '四、 为保障有讲APP相关功能的实现与应用安全稳定运行，我们产品中包含其他第三方SDK或其他类似应用程序，如您在我们平台上使用这类由第三方提供的服务时，您同意将由其直接收集和处理您的信息。前述服务商收集和处理信息等行为遵守其自身的隐私条款，不适用于本隐私政策。您可以查看附件一 第三方SDK目录并了解其隐私政策。',
      '4.2. 公开披露',
      '公开披露是指向社会或不特定人群发布信息的行为。正常情况下我们不会对您的个人信息进行公开披露。如具备合理事由确需公开披露的，我们会在公开披露之前向您告知公开披露的信息的目的、类型，如涉及个人敏感信息的，我们会向您告知涉及的敏感信息的内容，并在征得您确定同意后再公开披露，但法律法规另有规定或本隐私政策另有约定的除外。',
      '我们仅会在如下情况下，公开披露您的个人信息：',
      '4.2.1. 事先获得您的明确同意；',
      '4.2.2. 为提供您所要求的产品和服务，而必须和第三方分享您的个人信息；',
      '4.2.3. 根据法律的有关规定，或者行政或司法机构的要求，向第三方或者行政、司法机构披露；',
      '4.2.4. 如您出现违反中国有关法律、法规或者本应用服务政策或相关规则的情况，需要向第三方披露；',
      '4.2.5. 如您是知识产权投诉人并已提起投诉，应被投诉人要求，向被投诉人披露，以便双方处理可能的权利纠纷；',
      '4.2.6. 在本应用平台上创建的某一交易中，如交易任何一方履行或部分履行了交易义务并提出信息披露请求的，本应用有权决定向该用户提供其交易对方的联络方式等必要信息，以促成交易的完成或纠纷的解决；',
      '4.2.7. 其它本应用根据法律、法规或者网站政策认为合适的披露。',
      '4.3. 转让',
      '4.3.1. 除非获得您的明确同意，我们不会将您的个人信息转让给任何公司、组织或个人。',
      '4.3.2. 如发生合并、收购或破产清算情形，将可能涉及个人信息转让，此种情况下我们会要求心得持有您个人信息的公司、组织继续受本隐私政策的约束，否则我们将要求该公司、组织和个人重新向您征求授权同意。',
      '4.4. 请您知悉，根据法律法规的规定，在以下情况下，共享、公开披露、转让您的个人信息无需取得您的授权同意即：',
      '4.4.1. 与国家安全、国防安全有关的；',
      '4.4.2. 与公共安全、公共卫生、重大公共利益相关的；',
      '4.4.3. 与犯罪侦查、起诉、审判和判决执行等直接相关的；',
      '4.4.4. 出于维护您或其他个人的生命、财产等重大合法权益但又很难得到您本人同意的；',
      '4.4.5. 所收集的信息是您自行向社会公开的或者是从合法公开的渠道（如合法的新闻报道、政府信息公开等渠道）中收集到的；',
      '4.4.6. 根据与您签订和履行相关政策或其他书面文件所必需的；',
      '4.4.7. 有权机关的要求、法律法规等规定的其他情形。'
    ]
  },
  {
    title: '5. 关于使用Cookie和同类技术',
    texts: [
      '5.1. Cookie和设备信息标识等同类技术是互联网中普遍使用的技术。当您使用有讲课堂产品时，我们可能会使用相关技术向您的设备发送一个或多个Cookie或匿名标识符，以收集、标识您访问、使用本产品时的信息。我们承诺，不会将Cookie和同类技术用于本隐私政策所述目的外的任何途径。',
      '5.2. 您有权选择接受或拒绝接受Cookie和同类技术收集和使用您的相关信息。您可以通过修改浏览器设置的方式管理、拒绝Cookie与/或同类技术，或删除已经存储在您的计算机、移动设备或其他装置内的Cookie与/或同类技术，例如，您可以在APP首页下方『我的』》右上角『设置』》『清除缓存』，清除缓存的Cookie信息，从而实现我们无法全部或部分追踪您的个人信息。',
      '5.3. 如果您选择拒绝接受Cookie或同类技术，则您可能无法登录或无法使用依赖于Cookie的本应用网络服务或功能，同时也可能对您的信息保护和账号安全性造成一定的影响；',
      '5.4. 通过本应用所设Cookie和同类技术所取得的有关信息，将适用本隐私政策。'
    ]
  },
  {
    title: '6. 我们对您个人信息的存储与保护',
    texts: [
      '6.1. 信息存储',
      '6.1.1. 存储地点：',
      '我们依照法律法规的规定，仅会将收集到的有关您的个人信息存储于中华人民共和国境内。如果确有必要进行数据的跨境传输，我们会单独向您明确告知并征得您的授权同意，同时我们会确保数据接收方有充足的数据保护能力来保护您的个人信息。',
      '6.1.2. 存储期限：',
      '我们只会在达到本隐私政策所述目的所需的期限内保留您的个人信息，除非法律有强制的存留要求。而我们判断前述期限的标准包括：',
      '一、 完成与您相关的服务目的、维护相应服务及业务记录、应对您可能的查询或投诉；',
      '二、 保证我们为您提供服务的安全和质量；',
      '三、 您是否同意更长的留存期间；',
      '四、 是否存在保留期限的其他特别约定。',
      '五、 在您的个人信息超出保留期限后，我们会根据适用法律的要求删除您的个人信息。',
      '6.2. 信息保护',
      '6.2.1. 我们非常重视您个人信息的安全，将努力采取合理的安全措施，包括技术方面和管理方面来保护您的个人信息，防止您提供的个人信息被不当使用或在未经授权的情况下被访问、公开披露、使用、修改、损坏、丢失或泄露。',
      '6.2.2. 我们将采取严格的数据访问制度，确保只有授权人员才可访问您的个人信息，并适时对数据和技术进行安全审计。',
      '6.2.3. 希望您知悉并理解，您接入本应用的系统和通讯网络，可能因我们可控范围外的因素而出现问题。我们强烈建议您采取积极措施保护个人信息的安全，包括但不限于定期修改第三方账号密码、使用手机号验证码登录等，',
      '6.2.4. 尽管已经采取了合理有效的措施，并遵守相关法律法规要求的标准，在使用本应用网络服务进行网上交易时存在着各种恶意手段，我们不能保证信息百分百的安全，我们将尽力确保您提供给我们的个人信息的安全性。',
      '6.2.5. 如您发现自己的个人信息泄密，请您立即通过本隐私政策第十条提供的方式联系我们，以便我们采取相应措施。'
    ]
  },
  {
    title: '7. 您管理个人信息的权利',
    texts: [
      '我们非常重视您对个人信息的关注，并尽全力保护您对于自己个人信息访问、更正、删除以及撤回授权的权利，以使您拥有充分的能力保障您的隐私和安全。您的权利包括：',
      '7.1. 访问您的个人信息',
      '你可以按照我们提供的产品和服务的相关说明（设置），对您已提供给我们的相关个人信息进行查阅。包括：',
      '7.1.1. 账号信息：您可以通过相关产品页面随时访问或编辑您的个人资料信息，登录账号后通过我的》设置》个人资料查看此类信息，包括：头像、昵称、简介、ID、性别、生日、学习目的、感兴趣的、所在地、学历、行业、职业；',
      '7.1.2. 使用信息：您可以通过相关产品页面随时查阅您的使用信息，包括：收藏内容、下载内容、我的直播间内容、学习记录等；',
      '7.1.3. 其他信息：如您在访问过程中遇到操作问题需获取其他前述无法获知的个人信息内容，您可通过本隐私政策第十条提供的方式联系我们。',
      '7.2. 更正/修改您的个人信息',
      '7.2.1. 当您发现您提供给我们的个人信息存在登记错误、不完整或有更新的，您可在我们的产品和/或服务中更正/修改您的个人信息。',
      '7.2.2. 对于您的部分个人信息，我们在产品的相关功能页面为您提供了操作设置，您可以直接进行更正/修改，例如：“头像/昵称/性别/生日”等在客户端中的更正/修改路径为：我的》设置》个人资料。',
      '7.2.3. 对于您在行使上述权利过程中遇到的困难，或者其他可能目前无法向您提供在线自行更正/修改服务的，经过对您身份的验证，且更正/修改不影响信息的客观性和准确性的情况下，您有权对错误或不完整的信息作出更正或修改，或在特定情况下，尤其是数据错误时，通过我们公布的反馈与报错等措施将您的更正/修改申请提交给我们，要求我们更正或修改您的数据，但法律法规另有规定的除外。',
      '7.3. 删除您的个人信息',
      '当发生以下情况时，您可以直接要求我们删除您的个人信息：',
      '一、 当我们处理个人信息的行为违反法律法规时；',
      '二、 当我们收集、使用您的个人信息，却未征得您的同意时；',
      '三、 当我们处理个人信息的行为违反了与您的约定时；',
      '四、 当您注销了本应用账号时；',
      '五、 当我们终止服务及运营时。',
      '7.4. 管理/撤回授权',
      '前文所述，我们提供的产品和服务的部分功能需要获得您使用设备的相关权限（包括：位置、相机、麦克风等，具体以产品实际获取的功能为准）。您可以在授权后随时撤回（或停止）对该权限的继续授权。如在小米系统安卓客户端撤回授权的路径为：设置》应用设置》授权管理》应用权限管理》有讲课堂，选择具体权限拒绝授权即可。',
      '您需理解，当您撤回授权后，我们无法继续为您提供撤回授权所对应的特定功能和/或服务。但您撤回授权的决定，不会影响此前基于您的授权而开展的个人信息处理。',
      '您也可以通过注销账号的方式，永久撤回我们继续收集您个人信息的全部授权。',
      '7.5. 注销账号',
      '您可以在我们的产品或服务中直接申请注销账户。关于您注销账户的方式以及您应满足的条件，请详见“注销账户”页面。 您注销账户后，我们将停止为您提供产品/服务，并依据您的要求，除法律法规另有规定外，我们将删除您的个人信息。如果您对注销账号有疑问的，您可通过本隐私政策第十条提供的方式联系我们。',
      '“注销账户”页面的查询方式：手机客户端：APP首页下方『我的』》右上角『设置』》『账号与安全』》『注销账号』。'
    ]
  },
  {
    title: '8. 我们如何处理未成年人的个人信息',
    texts: [
      '8.1. 我们的服务主要面向成年人（原则上18周岁以上为成年人，16周岁以上且以自己的劳动成果为主要生活来源的，我们亦视为成年人）。',
      '8.2. 如您为未成年人，未成年人使用我们的产品与/或服务前应取得其监护人的同意，在使用我们的产品与/或服务前，应在监护人监护、指导下共同阅读本隐私政策且应在监护人明确同意和指导下使用我们的产品与/或服务或向我们提供信息。',
      '8.3. 我们根据国家相关法律法规的规定保护未成年人的个人信息，只会在法律法规允许、监护人明确同意或保护您的权益所必要的情况下收集、使用或公开披露未成年人的个人信息；',
      '8.4. 如您的监护人不同意您按照本隐私政策使用我们的服务或向我们提供信息，请您立即终止使用我们的服务并及时通知我们；',
      '8.5. 若您是未成年人的监护人，当您对您所监护的未成年人的个人信息有相关疑问时，您可以通过本隐私政策第十条“联系我们”中公示的联系方式与我们沟通解决。如果我们发现在未事先获得可证实的监护人同意的情况下收集了未成年人的个人信息，则会尽快删除相关数据。'
    ]
  },
  {
    title: '9. 本隐私政策如何更新',
    texts: [
      '9.1. 为给您提供更好的服务以及随着我们业务的发展，可能会对本应用的功能和提供的服务有所调整变化。原则上，当新功能或服务与我们当前提供的功能或服务相关时，收集与使用的个人信息将与原处理的目的具有直接或合理关联。在与原处理的无直接或合理关联的场景下，我们收集、使用您的个人信息，会再次进行告知，并征得您的同意。未经您明确同意，我们不会削减您依据本隐私政策所应享受的权利。',
      '9.2. 如果决定更改本隐私政策，我们会在本协议中、公司网站中以及我们认为适当的位置发布这些更改，以便您了解我们如何收集、使用您的个人信息，哪些人可以访问这些信息，以及在什么情况下我们会透露这些信息。',
      '9.3. 我们将保留随时修改本隐私政策的权利，因此请经常查看。您可以在有讲课程APP通过以下方式查阅我们的最新的隐私政策：『我的』》右上角『设置』按钮 》『隐私政策』。'
    ]
  },
  {
    title: '10. 联系我们',
    texts: [
      '如您对本隐私政策有任何疑问、意见或建议，或您在使用我们提供的服务时个人信息受到了侵扰，您可以通过以下几种方式联系我们，我们将尽快审核所涉问题，一般情况下，我们将在15个工作日内回复。',
      '一、 您可以通过以下方式直接与我们的客服联系：',
      '联系方式：020-87553865；',
      '电子邮箱地址：hezhihao@yojiang.cn;',
      '二、 周一至周五 09：00~18：00可通过有讲课堂APP与我们的客服联系，联系客服的路径是：『首页』》右上角『客服』；',
      '三、 通过意见反馈的方式将您的意见、反馈等发送给我们，意见反馈的路径是：『我的』》『意见反馈』；'
    ]
  },
  {
    title: '11. 争议解决',
    texts: [
      '11.1. 因本隐私政策生效、履行、解释及使用本应用平台或服务而产生或与本隐私政策相关的一切争议、权利主张或其他事项，均适用中华人民共和国大陆地区法律。',
      '11.2. 任何因本隐私政策以及我们处理您的个人信息事宜引起的争议，应先友好协商，如协商不成的，任何一方可选择按下述任一途径解决：',
      '一、 提交仲裁委员会，按照申请仲裁时现行有效的仲裁规则进行仲裁；仲裁裁决为终局裁决，对双方均有法律约束力；',
      '二、 提交协议签订地人民法院诉讼管辖；',
      '本隐私政策的标题仅为方便及阅读而设，并不影响正文其中任何规定的含义或解释。',
      '请您再次确认您已全部阅读并充分理解上述条款。'
    ]
  },
];

// ios第三方SDK目录
export const iosSdkContent = [
  {
    name: '支付宝SDK',
    desc: '支付',
    purpose: '为用户提供支付功能',
    attach: '用户点击立即购买按钮',
    get_msg: '设备标识符',
    compay: '支付宝(中国)网络技术有限公司',
    link_1: 'https://open.alipay.com/platform/home.htm',
    link_2: 'https://render.alipay.com/p/f/fd-jm7jym6r/alipay/multi-agreement.html'
  },
  {
    name: '微信支付SDK',
    desc: '支付',
    purpose: '为用户提供支付功能',
    attach: '用户点击立即购买按钮',
    get_msg: '设备标识符',
    compay: '深圳市腾讯计算机系统有限公司',
    link_1: 'https://pay.weixin.qq.com/wiki/doc/apiv3/index.shtml',
    link_2: 'https://weixin.qq.com/cgi-bin/readtemplate?t=weixin_business_pay'
  },
  {
    name: '腾讯Bugly SDK',
    desc: '用户投诉反馈',
    purpose: '帮助用户查询操作问题',
    attach: '用户点击意见反馈按钮',
    get_msg: '设备标识符、网络状态、系统版本、app版本',
    compay: '深圳市腾讯计算机系统有限公司',
    link_1: 'https://bugly.qq.com/v2/',
    link_2: 'https://bugly.qq.com/v2/contract'
  },
  {
    name: 'Umeng（友盟）SDK',
    desc: '统计分析用户行为，推送消息提醒',
    purpose: '提醒用户课程更新，更好的为客户提供服务',
    attach: '安卓APP成功后',
    get_msg: '设备标识符、网络状态、系统版本',
    compay: '北京锐讯灵通科技有限公司',
    link_1: 'https://www.umeng.com/',
    link_2: 'https://www.umeng.com/policy'
  },
  {
    name: '微博开放平台SDK',
    desc: '支持微博授权登录，帮助用户分享内容至第三方应用',
    purpose: '提供第三方登录功能',
    attach: '登录平台、分享页面',
    get_msg: '设备标识信息',
    compay: '新浪网络技术股份有限公司',
    link_1: 'https://open.weibo.com/',
    link_2: 'https://open.weibo.com/wiki/开发者协议'
  },
  {
    name: 'QQ互联移动终端SDK',
    desc: '支持QQ授权登录，帮助用户分享内容至第三方应用',
    purpose: '提供第三方登录功能',
    attach: '登录平台、分享页面',
    get_msg: '设备标识信息',
    compay: '深圳市腾讯计算机系统有限公司',
    link_1: 'https://connect.qq.com/index.html',
    link_2: 'https://wiki.connect.qq.com/qq互联sdk隐私保护声明'
  },
  {
    name: '微信开发平台SDK',
    desc: '支持微信授权登录，微信分享和微信支付',
    purpose: '提供第三方登录功能',
    attach: '登录平台、分享页面',
    get_msg: '设备标识信息',
    compay: '深圳市腾讯计算机系统有限公司',
    link_1: 'https://open.weixin.qq.com/',
    link_2: 'https://privacy.qq.com/'
  },
  {
    name: '网易七鱼SDK',
    desc: '客服供应商',
    purpose: '帮助用户对接客服',
    attach: '用户点击咨询按钮',
    get_msg: '设备标识信息',
    compay: '网易(杭州)网络有限公司',
    link_1: 'http://qiyukf.com/',
    link_2: 'http://corp.163.com/gb/legal.html'
  },
  {
    name: '腾讯直播SDK',
    desc: '收听观看音视频直播',
    purpose: '使用技术能力，需要提供相应的信息才能使用',
    attach: '打开音视频直播课程页面',
    get_msg: '设备标识符、系统版本',
    compay: '深圳市腾讯计算机系统有限公司',
    link_1: 'https://cloud.tencent.com/document/product/454',
    link_2: 'https://cloud.tencent.com/document/product/301/11470'
  },
  {
    name: 'Jgraph',
    desc: 'UI设计',
    purpose: '为用户展示相关图表信息',
    attach: '打开签到页面',
    get_msg: '获取已安装APP信息',
    compay: '个人',
    link_1: 'https://github.com/ZuYun/Jgraph',
    link_2: 'https://github.com/ZuYun/Jgraph'
  }
];
// android第三方SDK目录
export const androidSdkContent = [
  {
    name: '支付宝SDK',
    desc: '支付',
    purpose: '为用户提供支付功能',
    attach: '用户点击立即购买按钮',
    get_msg: '设备标识符',
    compay: '支付宝(中国)网络技术有限公司',
    link_1: 'https://open.alipay.com/platform/home.htm',
    link_2: 'https://render.alipay.com/p/f/fd-jm7jym6r/alipay/multi-agreement.html'
  },
  {
    name: '微信支付SDK',
    desc: '支付',
    purpose: '为用户提供支付功能',
    attach: '用户点击立即购买按钮',
    get_msg: '设备标识符',
    compay: '深圳市腾讯计算机系统有限公司',
    link_1: 'https://pay.weixin.qq.com/wiki/doc/apiv3/index.shtml',
    link_2: 'https://weixin.qq.com/cgi-bin/readtemplate?t=weixin_business_pay'
  },
  {
    name: '腾讯Bugly SDK',
    desc: '用户投诉反馈',
    purpose: '帮助用户查询操作问题',
    attach: '用户点击意见反馈按钮',
    get_msg: '设备标识符、网络状态、系统版本、app版本',
    compay: '深圳市腾讯计算机系统有限公司',
    link_1: 'https://bugly.qq.com/v2/',
    link_2: 'https://bugly.qq.com/v2/contract'
  },
  {
    name: 'Umeng（友盟）SDK',
    desc: '统计分析用户行为，推送消息提醒',
    purpose: '提醒用户课程更新，更好的为客户提供服务',
    attach: '安卓APP成功后',
    get_msg: '设备标识符、网络状态、系统版本',
    compay: '北京锐讯灵通科技有限公司',
    link_1: 'https://www.umeng.com/',
    link_2: 'https://www.umeng.com/policy'
  },
  {
    name: '微博开放平台SDK',
    desc: '支持微博授权登录，帮助用户分享内容至第三方应用',
    purpose: '提供第三方登录功能',
    attach: '登录平台、分享页面',
    get_msg: '设备标识信息',
    compay: '新浪网络技术股份有限公司',
    link_1: 'https://open.weibo.com/',
    link_2: 'https://open.weibo.com/wiki/开发者协议'
  },
  {
    name: 'QQ互联移动终端SDK',
    desc: '支持QQ授权登录，帮助用户分享内容至第三方应用',
    purpose: '提供第三方登录功能',
    attach: '登录平台、分享页面',
    get_msg: '设备标识信息',
    compay: '深圳市腾讯计算机系统有限公司',
    link_1: 'https://connect.qq.com/index.html',
    link_2: 'https://wiki.connect.qq.com/qq互联sdk隐私保护声明'
  },
  {
    name: '微信开发平台SDK',
    desc: '支持微信授权登录，微信分享和微信支付',
    purpose: '提供第三方登录功能',
    attach: '登录平台、分享页面',
    get_msg: '设备标识信息',
    compay: '深圳市腾讯计算机系统有限公司',
    link_1: 'https://open.weixin.qq.com/',
    link_2: 'https://privacy.qq.com/'
  },
  {
    name: '网易七鱼SDK',
    desc: '客服供应商',
    purpose: '帮助用户对接客服',
    attach: '用户点击咨询按钮',
    get_msg: '设备标识信息',
    compay: '网易(杭州)网络有限公司',
    link_1: 'http://qiyukf.com/',
    link_2: 'http://corp.163.com/gb/legal.html'
  },
  {
    name: '腾讯直播SDK',
    desc: '收听观看音视频直播',
    purpose: '使用技术能力，需要提供相应的信息才能使用',
    attach: '打开音视频直播课程页面',
    get_msg: '设备标识符、系统版本',
    compay: '深圳市腾讯计算机系统有限公司',
    link_1: 'https://cloud.tencent.com/document/product/454',
    link_2: 'https://cloud.tencent.com/document/product/301/11470'
  },
  {
    name: 'Jgraph',
    desc: 'UI设计',
    purpose: '为用户展示相关图表信息',
    attach: '打开签到页面',
    get_msg: '获取已安装APP信息',
    compay: '个人',
    link_1: 'https://github.com/ZuYun/Jgraph',
    link_2: 'https://github.com/ZuYun/Jgraph'
  },
  {
    name: 'com.blankj',
    desc: 'UI设计',
    purpose: '使用了解析Json数据；获取AppSDK相关信息；管理App中碎片生命周期；文件管理（文件读取、文件存储等）；获取系统版本号；状态栏管理（设置状态栏是否可见、设置导航栏颜色等）等功能。SDK有通讯录和短信等功能，本软件没有使用。',
    attach: '',
    get_msg: '获取Android_ID',
    compay: '个人',
    link_1: 'https://github.com/Blankj/AndroidUtilCode',
    link_2: 'https://github.com/Blankj/AndroidUtilCode'
  }
];

// android协议版本更新时间以及生效时间
export const andriodSeriesTime = {
  update_time_desc: '版本更新时间：2022年4月7日',
  effect_time_desc: '版本生效时间：2022年4月7日'
};

// ios协议版本更新时间以及生效时间
export const iosSeriesTime = {
  update_time_desc: '版本更新时间：2022年4月7日',
  effect_time_desc: '版本生效时间：2022年4月7日'
};
